/**
 * Orbiting content-type icons that circle around the kiwi mascot.
 *
 * Uses @property CSS custom property animation: the parent animates
 * --orbit-angle from 0 to 360deg, and each icon uses it in its own
 * transform: rotate(base + angle) translateX(radius) rotate(-(base + angle)).
 * This guarantees the orbit is always centered and icons stay upright.
 */

import {
  Rss,
  Headphones,
  PlayCircle,
  FileText,
  Film,
  BookOpen,
  Music,
  Link,
} from "lucide-react";

const ORBIT_ICONS = [
  { Icon: PlayCircle, size: 26 },
  { Icon: FileText, size: 16 },
  { Icon: Headphones, size: 22 },
  { Icon: Film, size: 14 },
  { Icon: Rss, size: 20 },
  { Icon: BookOpen, size: 12 },
  { Icon: Music, size: 24 },
  { Icon: Link, size: 15 },
];

interface ContentOrbitViewProps {
  radius?: number;
  color?: string;
}

export function ContentOrbitView({
  radius = 80,
  color = "var(--primary)",
}: ContentOrbitViewProps) {
  const count = ORBIT_ICONS.length;

  return (
    <div
      className="absolute inset-0 orbit-driver"
      style={{ "--orbit-radius": `${radius}px` } as React.CSSProperties}
    >
      {ORBIT_ICONS.map((item, index) => {
        const baseDeg = (360 / count) * index;
        return (
          <div
            key={index}
            className="orbit-item absolute left-1/2 top-1/2"
            style={{ "--base-angle": `${baseDeg}deg` } as React.CSSProperties}
          >
            <item.Icon size={item.size} style={{ color }} className="opacity-45" />
          </div>
        );
      })}
    </div>
  );
}
